'use strict';
import {applyDefaultReduxListComponentOptions} from '../../core-utilities/redux/ReduxListContainer';
import {SYNC_PATH} from '../../core-utilities/rx-utils';
import * as TASK_TYPE from '../../tasks/enums/TASK_TYPE';
import {TIMER_ACTIVITIES_COLLECTION} from '../domain/config';
import {getProjectTaskLog} from '../reducers/state';
import {buildTimerLogList, REDUX_OPTIONS} from './timerLogConfig';
import {PROJECT_TASK_LOG_PREFIX} from './state';
import {logger} from './logger';


/** @type {ReduxList} */
export const reduxList = buildTimerLogList({
  prefix: PROJECT_TASK_LOG_PREFIX,
  getState: getProjectTaskLog,
  listPath: parentId => `project-tasks/${parentId}/${TIMER_ACTIVITIES_COLLECTION}`,
  listSyncPath: parentId => `project-tasks/${parentId}/${TIMER_ACTIVITIES_COLLECTION}/${SYNC_PATH}`,
  logger,
}, {
  taskType: TASK_TYPE.PROJECT,
});

export const componentOptions = applyDefaultReduxListComponentOptions(reduxList.options, REDUX_OPTIONS);



// WEBPACK FOOTER //
// ./src/js/timers/redux/projectTaskTimerLog.js